import styled from 'styled-components'

import { helpers } from 'styles'

export const Type = styled.code`
	font-family: ${helpers.font.family.base};
	font-weight: 500;
	opacity: 0.7;

	&:empty {
		display: none;
	}
`
